module.exports = __webpack_public_path__ + "img/marker.png";